import {
    FormSelectAccount,
    FormSelectRole,
    FormTextBox,
    IDynamicFormRow,
} from '@src/components';
import { INPUT_CONFIG } from '@src/constants/inputConfig';
import { isValidEmail } from '@src/utilities/validation';
import { HiPlus } from 'react-icons/hi2';
type UserSchemaProps = {
    t: (key: string, options?: Record<string, any>) => string;
    accountId?: string;
    onAccountChange?: (value: any) => void;
    addNewRole?: () => void;
};

export function UserSchema({
    t,
    accountId,
    onAccountChange,
    addNewRole,
}: UserSchemaProps): IDynamicFormRow[] {
    return [
        {
            label: t('pages.users.forms.accountName'),
            keyName: 'account',
            Component: FormSelectAccount,
            formProps: {
                allowClear: true,
            },
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('pages.users.forms.accountName'),
                    }),
                },
                onChange: (e) => {
                    const value = e?.target?.value;
                    onAccountChange?.(value ?? undefined);
                },
            },
        },
        {
            label: t('forms.email'),
            keyName: 'email',
            inputProperties: {
                placeholder: 'email',
                type: 'email',
            },
            formProps: {
                maxLength: INPUT_CONFIG.SHORT_TEXT.maxLength,
            },
            Component: FormTextBox,
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.email'),
                    }),
                },
                validate: (email) => {
                    if (!isValidEmail(email))
                        return t('errors.formErrors.email');
                    return true;
                },
            },
        },
        {
            label: t('forms.role'),
            keyName: 'role',
            Component: FormSelectRole,
            registerOptions: {
                required: {
                    value: true,
                    message: t('errors.formErrors.required', {
                        name: t('forms.role'),
                    }),
                },
            },
            formProps: {
                customOption: {
                    label: (
                        <span
                            className="text-primary flex gap-2 items-center"
                            onClick={addNewRole}
                        >
                            <HiPlus size={16} />
                            {t('pages.users.forms.createNewRole')}
                        </span>
                    ),
                    value: 'custom',
                },
                size: 'large',
                requireAccountId: true,
                accountId: accountId,
            },
        },
    ];
}
